import type { Guia } from '../tipos';

export const guiaCadastro: Guia = {
  id: 'cadastro',
  titulo: 'Buscar e cadastrar gestante e parceiro',
  resumo:
    'Como encontrar a gestante, evitar cadastro duplicado, cadastrar e corrigir os dados e o parceiro.',
  perfis: ['recepcao', 'enfermeiro', 'medico'],
  revisadoEm: '2026-10-17',
  secoes: [
    {
      id: 'buscar',
      titulo: 'Buscar antes de cadastrar',
      passos: [
        'No menu, abra **Gestantes e parceiros**. De qualquer tela, o atalho Ctrl+K (⌘K no Mac) leva direto à busca.',
        'Digite o CPF, o CNS, a data de nascimento (dd/mm/aaaa) ou parte do nome e clique em **Buscar**. Maiúsculas e acentos não importam.',
        'Se ela aparecer na lista, clique no nome para abrir a ficha. Só cadastre se a busca não encontrar.',
      ],
      observacao:
        'Médico, enfermeiro e gestor também veem, abaixo da busca, as gestantes em acompanhamento do município, da data provável do parto mais próxima à mais distante. Depois de uma busca, **Ver as gestantes em acompanhamento** volta para essa lista.',
      botoes: ['Buscar', 'Ver as gestantes em acompanhamento'],
      imagem: {
        arquivo: 'cadastro-busca.png',
        descricao:
          'Página Gestantes e parceiros com o campo de busca e a lista de gestantes em acompanhamento.',
      },
    },
    {
      id: 'cadastrar',
      titulo: 'Cadastrar a gestante',
      passos: [
        'Clique em **Cadastrar gestante**.',
        'Preencha pelo menos o **Nome completo**, a **Data de nascimento** e a **Unidade de referência**. Os outros campos ajudam a completar a ficha SINAN depois.',
        'Se a pessoa usa nome social, preencha **Nome social**: ele aparece em destaque nas telas.',
        'Clique em **Cadastrar gestante**. Se houver um cadastro parecido (mesmo nome e data de nascimento), o sistema avisa antes de salvar: confira se não é a mesma pessoa.',
      ],
      botoes: ['Cadastrar gestante'],
      imagem: {
        arquivo: 'cadastro-formulario.png',
        descricao:
          'Formulário de cadastro da gestante, com as seções Identificação, Contato e Endereço.',
      },
    },
    {
      id: 'corrigir',
      titulo: 'Corrigir o cadastro',
      passos: [
        'Abra a ficha e a aba **Cadastro**, corrija o que for preciso e clique em **Salvar alterações**.',
        'Cada alteração fica registrada (quem, quando, antes e depois).',
      ],
      observacao:
        'Para retirar um cadastro feito por engano, use **Inativar cadastro** e informe o motivo. Nada é apagado.',
      botoes: ['Salvar alterações', 'Inativar cadastro'],
    },
    {
      id: 'parceiro',
      titulo: 'Cadastrar o parceiro',
      passos: [
        'Na ficha da gestante, abra a aba **Parceiro**.',
        'Preencha os dados e clique em **Cadastrar parceiro**.',
        'Numa gestação nova, o sistema oferece **Reaproveitar dados do parceiro anterior**, se for a mesma pessoa.',
      ],
      observacao:
        'Os exames e o tratamento do parceiro ficam nesta mesma aba, separados dos da gestante.',
      botoes: ['Cadastrar parceiro', 'Reaproveitar dados do parceiro anterior'],
    },
  ],
};

export const guiaGestacao: Guia = {
  id: 'gestacao',
  titulo: 'Abrir a gestação',
  resumo: 'DUM, idade gestacional, data provável do parto, unidade de pré-natal e risco.',
  perfis: ['enfermeiro', 'medico'],
  revisadoEm: '2026-10-17',
  secoes: [
    {
      id: 'abrir',
      titulo: 'Abrir a gestação',
      passos: [
        'Na ficha da gestante, abra a aba **Gestação**.',
        'Informe a **Data da última menstruação (DUM)**: o sistema calcula na hora a idade gestacional e a **Data provável do parto (DPP)**.',
        'Escolha a **Unidade de pré-natal** e o **Risco gestacional**.',
        'Clique em **Abrir gestação**. A partir daí aparecem as abas Pré-natal, Exames e Tratamento.',
      ],
      observacao:
        'Só há uma gestação em andamento por vez. Só quem registrou edita; outra pessoa usa **Novo**, com justificativa.',
      botoes: ['Abrir gestação'],
      imagem: {
        arquivo: 'gestacao-aba.png',
        descricao:
          'Aba Gestação com a DUM, a idade gestacional e a data provável do parto calculadas.',
      },
    },
    {
      id: 'recepcao',
      titulo: 'E a recepção?',
      passos: [
        'A recepção cadastra a gestante e o parceiro, mas não abre a gestação: a DUM é dado clínico.',
        'Depois do cadastro, encaminhe a gestante para o enfermeiro ou o médico.',
      ],
    },
  ],
};
